module.exports = __webpack_public_path__ + "img/ah04.47edde5f.jpg";